export const MARITAL_STATUS_SAVE = 'MARITAL_STATUS_SAVE';
